module.exports = __webpack_public_path__ + "img/Club-slider7-clubDetails.540a6fea.png";